module.exports = __webpack_public_path__ + "static/media/LARV-innovationsrum-inbjudan.1943d12b.pdf";